"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchResponseToResultPage = exports.transformProperty = exports.getAddress = exports.photoStrToPhotos = exports.reverseMapLeaseInc = exports.photoTypeMap = exports.toPhotoPath = exports.photoPathPrefixMap = exports.listTypeIdRevMap = exports.listTypeIdMap = void 0;
var ResultPageState_1 = require("@/pages/search/states/ResultPageState");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var LayoutState_1 = require("@/pages/common/states/LayoutState");
var effects_1 = require("redux-saga/effects");
var stateFilter_1 = require("@/pages/common/sagas/stateFilter");
var UserPropertiesCrud_1 = require("@/pages/saveproperties/sagas/UserPropertiesCrud");
exports.listTypeIdMap = {
    1: SfilterTypeGroup_1.SfilterType.BUY,
    2: SfilterTypeGroup_1.SfilterType.RENT,
    3: SfilterTypeGroup_1.SfilterType.BUYRENT,
    4: SfilterTypeGroup_1.SfilterType.ALL,
};
exports.listTypeIdRevMap = {
    0: 1,
    1: 2,
    2: 3,
    3: 4,
};
exports.photoPathPrefixMap = {
    PP_0: 'property/wp406_229/',
    PP_1: 'property/wp825_485/',
    BB_0: 'block/wp406_229/',
    BB_1: 'block/wp825_485/',
    BP_0: 'building/wp406_229/',
    BP_1: 'building/wp825_485/',
    FP_0: 'floorplan/wp406_229/',
    FP_1: 'floorplan/wp825_485/',
    DEFAULT_0: 'building/wp406_229/',
    DEFAULT_1: 'building/wp825_485/',
};
exports.toPhotoPath = function (name, type, imgDomain, size) {
    if (size === void 0) { size = 0; }
    var typePrefix = type.toUpperCase() + "_" + size;
    var relativePath = exports.photoPathPrefixMap[typePrefix]
        ? exports.photoPathPrefixMap[typePrefix]
        : exports.photoPathPrefixMap[typePrefix];
    var path = imgDomain + "/" + relativePath + name;
    return path;
};
exports.photoTypeMap = {
    PP: 'Property Photo',
    BP: 'Building Photo',
    FP: 'Floor Plan Photo',
};
exports.reverseMapLeaseInc = function (str) {
    if (ResultPageState_1.ResultIncludeManagementFee.EXCLUDE === str) {
        return ResultPageState_1.ResultIncludeManagementFee.EXCLUDE;
    }
    if (ResultPageState_1.ResultIncludeManagementFee.INCLUDE === str) {
        return ResultPageState_1.ResultIncludeManagementFee.INCLUDE;
    }
    if (ResultPageState_1.ResultIncludeManagementFee.UNKNOWN === str) {
        return ResultPageState_1.ResultIncludeManagementFee.UNKNOWN;
    }
};
exports.photoStrToPhotos = function (photoStr, id) {
    return photoStr ? photoStr
        .split('^')
        .filter(function (it) { return it; })
        .map(function (it, i) {
        var imageInfoPc = it.split('|');
        return {
            propertyListingId: id,
            photoName: imageInfoPc[0],
            photoType: imageInfoPc[1],
            isPrimary: i === 0 ? true : false,
        };
    }) : [];
};
exports.getAddress = function (streetNo, streetName, t, languageId) {
    if (!streetName)
        return 'N/A';
    if (languageId === LayoutState_1.Language.EN_US) {
        return streetNo ? streetNo + " " + streetName : streetName;
    }
    var streetNoStr = streetNo ? streetNo + " " + t.streetNumber : '';
    return streetName + " " + streetNoStr;
};
exports.transformProperty = function (it, type, t, languageId, imgDomain, isSaved) {
    var price = type === SfilterTypeGroup_1.SfilterType.BUY ? it.salePrice : it.leasePrice * 1000;
    var salePrice = it.salePrice;
    var leasePrice = it.leasePrice * 1000;
    var salePricePerSqftGross = it.sellpersqftGross;
    var leasePricePerSqftGross = it.leasepersqftGross;
    var salePricePerSqftSaleable = it.sellpersqftNet;
    var leasePricePerSqftSaleable = it.leasepersqftNet;
    var leasePricePerSqft = leasePricePerSqftSaleable
        ? leasePricePerSqftSaleable
        : leasePricePerSqftGross;
    var salePricePerSqft = salePricePerSqftSaleable
        ? salePricePerSqftSaleable
        : salePricePerSqftGross;
    var pricePerSqft = type === SfilterTypeGroup_1.SfilterType.BUY ? salePricePerSqft : leasePricePerSqft;
    var propertyPhotoes = [];
    var images = [];
    if (it.propertyPhotoImages && it.propertyPhotoImages.length) {
        images = it.propertyPhotoImages;
    }
    else {
        if (it.propertyPhoto ||
            it.propertyPhoto === '') {
            propertyPhotoes = exports.photoStrToPhotos(it.propertyPhoto, it.id);
        }
        else {
            propertyPhotoes = it.propertyPhotos;
        }
        images = propertyPhotoes.map(function (it) { return ({
            path: "" + exports.toPhotoPath(it.photoName, it.photoType, imgDomain),
            caption: exports.photoTypeMap[it.photoType.toUpperCase()],
        }); });
    }
    var isRelated = false;
    if (it.isRelated) {
        isRelated = it.isRelated;
    }
    var amenities = [
        {
            key: 'bed',
            value: it.bedrooms,
            displayKey: t['bedrooms'],
            displayValue: it.bedrooms + " " + t['bd'],
        },
        {
            key: 'bath',
            value: it.bathrooms,
            displayKey: t['bathrooms'],
            displayValue: it.bathrooms + " " + t['ba'],
        },
    ];
    if (it.totalMaidRoom) {
        amenities.push({
            key: 'maid',
            value: it.totalMaidRoom,
            displayKey: t['maidsroom'],
            displayValue: it.totalMaidRoom + " " + t['mr'],
        });
    }
    var isLeaseSubjectToOffer = it.isLeaseSTO === 1;
    var isSaleSubjectToOffer = it.isSaleSTO === 1;
    var isSubjectToOffer = type === SfilterTypeGroup_1.SfilterType.BUY ? isSaleSubjectToOffer : isLeaseSubjectToOffer;
    var isSoleAgent = Number(it.isSoleAgent) ? true : (it.banners || []).filter(function (it) { return it.label.toLowerCase().indexOf('sole') === 0 || it.label.toLowerCase().indexOf('獨') === 0 || it.label.toLowerCase().indexOf('独') === 0; }).length > 0 ? true : false;
    var isJointSoleAgent = Number(it.isJointSoleAgent) ? true : (it.banners || []).filter(function (it) { return it.label.toLowerCase().indexOf('joint') === 0 || it.label.toLowerCase().indexOf('聯') === 0 || it.label.toLowerCase().indexOf('联') === 0; }).length > 0 ? true : false;
    return {
        price: price,
        salePrice: salePrice,
        leasePrice: leasePrice,
        salePricePerSqftGross: salePricePerSqftGross,
        leasePricePerSqftGross: leasePricePerSqftGross,
        salePricePerSqftSaleable: salePricePerSqftSaleable,
        leasePricePerSqftSaleable: leasePricePerSqftSaleable,
        leasePricePerSqft: leasePricePerSqft,
        salePricePerSqft: salePricePerSqft,
        pricePerSqft: pricePerSqft,
        images: images,
        amenities: amenities,
        isRelated: isRelated,
        isLeaseSubjectToOffer: isLeaseSubjectToOffer,
        isSaleSubjectToOffer: isSaleSubjectToOffer,
        isSubjectToOffer: isSubjectToOffer,
        isSoleAgent: isSoleAgent,
        isJointSoleAgent: isJointSoleAgent,
        includeManagementFee: exports.reverseMapLeaseInc(it.leaseInc),
        building: it.buildingName,
        area: it.districtName ? it.districtName : it.areaName,
        districtId: it.districtId,
        address: exports.getAddress(it.streetNo, it.streetName, t, languageId),
        type: exports.listTypeIdMap[it.listingTypeId],
        sizeGross: it.grossSize,
        sizeSaleable: it.netSize,
        size: it.netSize ? it.netSize : it.grossSize,
        buildingAge: it.builtYear
            ? new Date().getFullYear() - Number(it.builtYear)
            : -1,
        floor: it.floorName,
        isSaved: isSaved,
        isSaving: false,
        isVirtual: it.isVirtual,
        isVideo: it.isVideo,
        lastUpdated: new Date(it.lastUpdatedDate),
        referenceId: it.id,
        lat: Number(it.latitude),
        lng: Number(it.longitude),
        banners: it.banners,
    };
};
exports.searchResponseToResultPage = function (response, type) {
    var state, languageId, imgDomain, savedPropertyIds;
    if (type === void 0) { type = SfilterTypeGroup_1.SfilterType.BUY; }
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select()];
            case 1:
                state = _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguage)];
            case 2:
                languageId = _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.getImageDomain)];
            case 3:
                imgDomain = _a.sent();
                return [4 /*yield*/, effects_1.call(UserPropertiesCrud_1.getSavedPropertyIds)];
            case 4:
                savedPropertyIds = _a.sent();
                return [2 /*return*/, {
                        page: response.pager ? response.pager.currentPage : 1,
                        pageTotal: response.pager ? response.pager.totalPages : 1,
                        results: response && response.properties && response.properties.length ? response.properties.map(function (it) { return exports.transformProperty(it, type, state.resultT, languageId, imgDomain, savedPropertyIds.indexOf(it.id) >= 0); }) : [],
                        resultTotal: response.pager ? response.pager.totalItems : 1,
                        heading: response.heading,
                        estatePhase: response.estatePhase,
                    }];
        }
    });
};
